// language=GraphQL
export const ALL_AGE_GROUPS_QUERY = `query Query {
  ageGroups: travelPricingAgeGroups {
    id
    name
    type
    icon
    minAge
    maxAge
  }
}`

// language=GraphQL
export const SINGLE_AGE_GROUP_QUERY = `query Query($id: ID!) {
  ageGroup: travelPricingAgeGroup(id: $id) {
    id
    name
    type
    icon
    minAge
    maxAge
  }
}`

// language=GraphQL
export const CREATE_AGE_GROUP_MUTATION = `
  mutation Mutation($input: CreateTravelPricingAgeGroupInput) {
    ageGroup: createTravelPricingAgeGroup(input: $input) {
      id
      name
      type
      icon
      minAge
      maxAge
    }
  }`

// language=GraphQL
export const UPDATE_AGE_GROUP_MUTATION = `
  mutation Mutation($input: UpdateTravelPricingAgeGroupInput) {
    ageGroup: updateTravelPricingAgeGroup(input: $input) {
      id
      name
      type
      icon
      minAge
      maxAge
    }
  }`

// language=GraphQL
export const DELETE_AGE_GROUP_MUTATION = `
  mutation Mutation($input: DeleteTravelPricingAgeGroupInput) {
    deleteTravelPricingAgeGroup(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_AGE_GROUP_MUTATION = `
  mutation Mutation($input: DeleteTravelPricingAgeGroupInput) {
    forceDeleteTravelPricingAgeGroup(input: $input) {
      success
    }
  }`
// language=GraphQL
export const AGE_GROUPS_DEPENDENTS_QUERY = `query Query($id: ID!, $withAccommodationAgeGroupCapacities: Boolean = false, $withRatioAgeGroupServices: Boolean = false, $withTravellers: Boolean = false, $withTravelPricingAgeGroupSettings: Boolean = false, $withAccommodationAgeGroupedTotalCapacities: Boolean = false, $withAccommodationCapacitySettings: Boolean = false, $withRatioPersonalAddons: Boolean = false, $withTravelPricingRules: Boolean = false) {
  groupedDependents: travelPricingAgeGroupDependents(id: $id) {
    accommodationAgeGroupCapacities @include(if: $withAccommodationAgeGroupCapacities) {
      id
      minCapacity
      maxCapacity    }
    ratioAgeGroupServices @include(if: $withRatioAgeGroupServices) {
      id
      ratioServiceNo    }
    travellers @include(if: $withTravellers) {
      id
      salutation
      firstName
      lastName
      birthday
      nationality
      email
      phone
      address
      addressNumber
      addressAddition
      zip
      city
      country
    }
    travelPricingAgeGroupSettings @include(if: $withTravelPricingAgeGroupSettings) {
      id
      freeUntilAge
    }
    accommodationAgeGroupedTotalCapacities @include(if: $withAccommodationAgeGroupedTotalCapacities) {
      id
      capacity    }
    accommodationCapacitySettings @include(if: $withAccommodationCapacitySettings) {
      id
      totalCapacity
      rangesAllowed
      partialOccupancyAllowed
    }
    ratioPersonalAddons @include(if: $withRatioPersonalAddons) {
      id
      ratioServiceNo
      name
      label
      info
    }
    travelPricingRules @include(if: $withTravelPricingRules) {
      id
      checkAccommodationTypes
      checkAccommodationAddons
      checkAgeGroups
      useAgeFilter
      checkDateRange
      startDate
      endDate
      checkTravelDate
    }
  }
}`
